import type { Judgement, Millis, Seconds, Verdict, Windows } from './types';

export const DESKTOP_WINDOWS: Windows = {
  perfect: 35,
  good: 80,
  lateWeak: 160,
};

export const MOBILE_WINDOWS: Windows = {
  perfect: 60,
  good: 120,
  lateWeak: 240,
};

export function judgeRelease(deltaMs: Millis, windows: Windows): Verdict {
  if (deltaMs < -windows.good) return 'flop';
  const magnitude = Math.abs(deltaMs);
  if (magnitude <= windows.perfect) return 'perfect';
  if (magnitude <= windows.good) return 'good';
  if (deltaMs <= windows.lateWeak) return 'weak';
  return 'miss';
}

export function deltaMsBetween(releaseSeconds: Seconds, apexSeconds: Seconds): Millis {
  return Math.round((releaseSeconds - apexSeconds) * 1e9) / 1e6;
}

export function judge(
  riserIndex: number,
  releaseSeconds: Seconds,
  apexSeconds: Seconds,
  windows: Windows,
): Judgement {
  const deltaMs = deltaMsBetween(releaseSeconds, apexSeconds);
  return { verdict: judgeRelease(deltaMs, windows), deltaMs, riserIndex };
}

export function holdTooLong(nowSeconds: Seconds, apexSeconds: Seconds, windows: Windows): boolean {
  return deltaMsBetween(nowSeconds, apexSeconds) > windows.lateWeak;
}

export function missJudgement(riserIndex: number, deltaMs: Millis): Judgement {
  return { verdict: 'miss', deltaMs, riserIndex };
}
